import { OtpComponent } from './views/otp/otp.component';
import { LoyaltyNumberComponent } from './views/loyalty-number/loyalty-number.component';
import { VisitedUsBeforeComponent } from './views/visited-us-before/visited-us-before.component';
import { Routes } from '@angular/router';

import { HostComponent } from './layout/host/host.component';

import { LogonGuardService } from '@picard/services-lib';

import { AuthorizationFailedComponent } from './views/authorization-failed/authorization-failed.component';
import { ErrorComponent } from './views/error/error.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ProfileComponent } from './views/profile/profile.component';
import { HistoryComponent } from './views/history/history.component';
import { LoginComponent } from './views/login/login.component';
import { TermsConditionsComponent } from './views/terms-conditions/terms-conditions.component';
import { PrivacyComponent } from './views/privacy/privacy.component';
import { BasketManagerComponent } from './views/basket-manager/basket-manager.component';
import { RegisterComponent } from './views/register/register.component';
import { LocationsComponent } from './views/locations/locations.component';
import { ActivateAccountComponent } from './views/activate-account/activate-account.component';
import { VoucherComponent } from './views/voucher/voucher.component';
import { VoucherHistoryComponent } from './views/voucher-history/voucher-history.component';
import { StoresComponent } from './views/stores/stores.component';
import { VoucherLandingComponent } from './views/voucher-landing/voucher-landing.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: HostComponent,
    canActivate: [LogonGuardService],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard/:open', component: DashboardComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'history', component: HistoryComponent },
      { path: 'terms', component: TermsConditionsComponent },
      { path: 'privacy', component: PrivacyComponent },
      { path: 'locations', component: LocationsComponent },
      { path: 'vouchers', component: VoucherComponent },
      { path: 'vouchers/:id', component: VoucherHistoryComponent },
      { path: 'stores', component: StoresComponent },
      { path: 'voucher-landing', component: VoucherLandingComponent }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'activate', component: ActivateAccountComponent},
  { path: 'visited-us-before', component: VisitedUsBeforeComponent },
  { path: 'loyalty-number', component: LoyaltyNumberComponent },
  { path: 'otp', component: OtpComponent },
  { path: 'basket-manager', component: BasketManagerComponent },
  { path: 'access-denied', component: AuthorizationFailedComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', component: NotFoundComponent }
];
